module.exports = __webpack_public_path__ + "static/DALIS_PORTES-4b967d84b86f9552c6b1bff7cc690f04.jpg";